import { CONTENT_TYPE } from "@educaplay/core";
import styles from "./bankContent.module.scss";
import clsx from "clsx";
import MediaBankContent from "./MediaBankContent";
import TextBankContent from "./TextBankContent";
import useHorizontalScroll from "../../utils/useHorizontalScroll";
import { useRef } from "react";

const BankContent = (props) => {
  const data = props.data;

  const allText = data.every((it) => it.type === CONTENT_TYPE.TEXT);

  const bankRef = useRef();
  useHorizontalScroll(bankRef, undefined, allText);

  return (
    <div
      ref={bankRef}
      className={clsx(styles.bank, allText && styles.onlyText)}
    >
      {allText && <TextBankContent {...props} />}
      {!allText && <MediaBankContent {...props} />}
    </div>
  );
};

export default BankContent;
